import React, { forwardRef, ReactNode, useImperativeHandle } from 'react';
import classNames from 'classnames';
import { Modal } from 'ncoded-component-library';
import {
  ModalProps,
  ModalRef,
} from 'ncoded-component-library/build/components/organisms/Modal/Modal.component';
import useCallbackRef from 'hooks/useCallbackRef';
import ActionItem from 'components/ActionItem';
import { ActionItemProps } from 'components/ActionItem/ActionItem.component';

import './ActionListModal.styles.scss';

type ActionListModalProps = {
  className?: string;
  title?: ReactNode;
  description?: string;
  items: ActionItemProps[];
} & ModalProps;

const ActionListModal: React.ForwardRefRenderFunction<
  ModalRef,
  ActionListModalProps
> = (props, ref) => {
  const { className, title, description, items, ...rest } = props;

  const [modal, modalRef] = useCallbackRef<ModalRef>();

  useImperativeHandle(ref, () => modal, [modal]);

  const classes = classNames('action-list-modal', className);

  return (
    <Modal ref={modalRef} className={classes} title={title} {...rest}>
      {description && (
        <p className="action-list-modal__description">{description}</p>
      )}

      <div className="action-list-modal__list">
        {items.map(({ onClick, ...rest }) => (
          <ActionItem
            key={rest.title}
            {...rest}
            onClick={() => {
              onClick();
              modal?.close();
            }}
          />
        ))}
      </div>
    </Modal>
  );
};

export default forwardRef(ActionListModal);
